<div class="cc-container">

    <!-- ===== Top section: Email CC Recipients ===== -->
    <div class="section-label">{{ 'EMAIL_CC_RECIPIENTS' | translate }}</div>

    <div class="table-scroll">
        <table mat-table [dataSource]="ccRecipientsDataSource" [trackBy]="trackByEmail" class="full-width">

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>{{ 'EMAIL' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="ccRecipientsColumns" class="row-height"></tr>
            <tr mat-row *matRowDef="let row; columns: ccRecipientsColumns;" (click)="onCcRecipientRowClick(row)"
                [class.selected]="ccRecipientsSelection.isSelected(row)" class="row-height">
            </tr>
        </table>
    </div>

    <!-- ===== Add / Remove buttons ===== -->
    <div class="action-buttons">
        <button mat-raised-button color="primary" [disabled]="!isAddEnabled" (click)="addToCcRecipients()">
            {{ 'ADD' | translate }} <mat-icon>arrow_upward</mat-icon>
        </button>
        <button mat-raised-button color="primary" [disabled]="!isRemoveEnabled" (click)="removeFromCcRecipients()">
            {{ 'REMOVE' | translate }} <mat-icon>arrow_downward</mat-icon>
        </button>
    </div>

    <!-- ===== Bottom section: Available Email CC Recipients ===== -->
    <div class="section-label">{{ 'AVAILABLE_EMAIL_CC_RECIPIENTS' | translate }}</div>

    <div class="table-scroll">
        <table mat-table [dataSource]="availableDataSource" [trackBy]="trackByEmail" class="full-width">

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef>{{ 'EMAIL' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.email }}</td>
            </ng-container>

            <!-- Remove (Cross) Column -->
            <ng-container matColumnDef="remove">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    @if(availableSelection.isSelected(element)){
                    <mat-icon class="delete-icon d-flex align-items-center justify-content-center"
                        (click)="deleteAvailableRecipient(element, $event);">delete_outline</mat-icon>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="availableColumns" class="row-height"></tr>
            <tr mat-row *matRowDef="let row; columns: availableColumns;" (click)="onAvailableRowClick(row)"
                [class.selected]="availableSelection.isSelected(row)" class="row-height">
            </tr>
        </table>
    </div>

    <!-- ===== Add CC Recipient button ===== -->
    <div class="add-cc-btn">
        <button mat-raised-button color="primary" (click)="addCcRecipient()"
            [disabled]="!isAddCcRecipientEnabled"><mat-icon>add</mat-icon>
            {{ 'ADD_CC_RECIPIENT_LABEL' | translate }}
        </button>
    </div>

</div>